import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: false,
  filterByPriceOptions: null,
  filterBySortingOptions: null,
  error: null,
};

// Filter By Price
const filterByPriceStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const filterByPriceSuccess = (state: any, action: any) => {
  return updateObject(state, {
    filterByPriceOptions: action.filterByPrice,
    error: null,
    loading: false,
  });
};

const filterByPriceFailed = (state: any, action: any) => {
  return updateObject(state, {
    filterByPriceOptions: null,
    error: action.error,
    loading: false,
  });
};

// Filter by sorting
const filterBySortingStart = (state: any) => {
    return updateObject(state, { error: null, loading: true });
};

const filterBySortingSuccess = (state: any, action: any) => {
  return updateObject(state, {
    filterBySortingOptions: action.filterBySorting,
    error: null,
    loading: false,
  });
};

const filterBySortingFailed = (state: any, action: any) => {
  return updateObject(state, {
    filterBySortingOptions: null,
    error: action.error,
    loading: false,
  });
};

const filterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // Filter By Price
    case actionTypes.FILTER_BY_PRICE_START:
      return filterByPriceStart(state);
    case actionTypes.FILTER_BY_PRICE_SUCCESS:
      return filterByPriceSuccess(state, action);
    case actionTypes.FILTER_BY_PRICE_FAIL:
      return filterByPriceFailed(state, action);
    // Filter by sorting
    case actionTypes.FILTER_BY_SORTING_START:
      return filterBySortingStart(state);
    case actionTypes.FILTER_BY_SORTING_SUCCESS:
      return filterBySortingSuccess(state, action);
    case actionTypes.FILTER_BY_SORTING_FAIL:
      return filterBySortingFailed(state, action);
    default:
      return state;
  }
};

export default filterReducer;
